<!-- @format -->

<sis-study-substitution-box
  [substituteCourseUnits]="substituteCourseUnits"
  [level]="headingLevel"
  (nameClickAction)="openCourseUnitInfoModal($event)">
</sis-study-substitution-box>
